import React from 'react'
import { AchCredit } from './achCredit'

export const AchCreditAPI = () => {
  return (
    <AchCredit />
  )
}
